import { Typography } from 'fronton-react';
import React from 'react';

interface SubtitleProps {
  subtitle?: string;
}

export const Subtitle: React.FC<SubtitleProps> = ({ subtitle }) => {
  if (!subtitle) return null;

  return (
    <Typography data-qa="products-carousel-subtitle" size="caption" variant="minor" color="text-minor">
      {subtitle}
    </Typography>
  );
};
